import { Box, Typography } from '@mui/material';
import moment from 'moment';
import styles from './WcpaHistoryTable.module.scss';

const HEADER = [
	{ label: 'LOT NO.', field: 'lotNumber' },
	{ label: 'VIN NO.', field: 'serialNumber' },
	{ label: 'ENGINE SERIAL NO.', field: 'engineSerialNumber' },
	{ label: 'LAST PROCESSED', field: 'wcpaTs' },
];

const WcpaHistoryTable = ({ title, rows = [] }) => {
	return (
		<Box className={styles.wcpaHistoryTable}>

			<Box className={styles.title}>
				<Typography className={styles.titleText}>
					{title}
				</Typography>

				<Typography className={styles.count}>
					{rows.length}
				</Typography>
			</Box>

			<Box className={styles.scroll}>

				<Box className={styles.header}>
					{HEADER.map((item) => (
						<Typography
							key={item.field}
							className={styles.headerCell}
						>
							{item.label}
						</Typography>
					))}
				</Box>

				{
					rows.length === 0 ? (

						<Box className={styles.empty}>
							<Typography>
								No Records Found
							</Typography>
						</Box>

					) : (

						rows.map((row, index) => (

							<Box
								key={index}
								className={styles.row}
							>

								<Typography className={styles.cell}>
									{row.lotNumber ?? '—'}
								</Typography>

								<Typography className={styles.cell}>
									{row.serialNumber ?? '—'}
								</Typography>

								<Typography className={styles.cell}>
									{row.engineSerialNumber ?? '—'}
								</Typography>

								<Typography className={styles.cell}>
									{
										row.wcpaTs
											? moment(row.wcpaTs).format(
													'DD-MM-YYYY HH:mm:ss',
											  )
											: '—'
									}
								</Typography>

							</Box>

						))

					)
				}

			</Box>

		</Box>
	);
};

export default WcpaHistoryTable;